import { render, staticRenderFns } from "./ContatosPcoCircuitoComponent.vue?vue&type=template&id=61ecab7e"
import script from "./ContatosPcoCircuitoComponent.vue?vue&type=script&lang=js"
export * from "./ContatosPcoCircuitoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports